module.exports = __WEBPACK_EXTERNAL_MODULE_26__;


//////////////////
// WEBPACK FOOTER
// external "ca-modeller/shaping"
// module id = 26
// module chunks = 0 1